<template>
  <DashboardDetailLayout
    title="Companies Added"
    subtitle="New companies entering the system over time, sliced by source and sector."
  >
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-1 mb-4">
      <MetricCard
        title="Added Today"
        value="37"
        trend="vs 42 avg/day"
        trendDirection="flat"
        :fakeData="true"
      />
      <MetricCard
        title="This Week"
        value="214"
        valueTone="good"
        trend="+8% vs prior week"
        trendDirection="up"
        :fakeData="true"
      />
      <MetricCard
        title="Last 30 Days"
        value="1286"
        valueTone="good"
        trend="+14% vs prior 30d"
        trendDirection="up"
        :fakeData="true"
      />
      <MetricCard
        title="Total in System"
        value="482910"
        subtitle="All-time"
        :fakeData="true"
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-1 mb-4">
      <ChartPlaceholder
        title="Added Per Day"
        subtitle="Last 30 days"
        :barCount="30"
        :seed="41"
        tall
      />
      <ChartPlaceholder
        title="Added Per Week"
        subtitle="Last 26 weeks"
        :barCount="26"
        :seed="47"
        tall
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-1 mb-4">
      <ChartPlaceholder
        title="By Source"
        subtitle="Last 30 days"
        :barCount="5"
        :seed="53"
      />
      <ChartPlaceholder
        title="By Sector"
        subtitle="Last 30 days"
        :barCount="8"
        :seed="59"
      />
      <ChartPlaceholder
        title="By Added-By User"
        subtitle="Top 8 users, last 30 days"
        :barCount="8"
        :seed="61"
      />
    </div>

    <div class="rounded-md border-2 border-dashed border-gray-300 bg-neutral-50 shadow p-3 m-2">
      <div class="flex flex-row items-center space-x-2 mb-2">
        <div class="text-sm tracking-widest text-gray-700 font-poppins uppercase">
          Most Recent Additions
        </div>
        <SampleBadge />
      </div>
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-gray-500 border-b">
            <th class="py-1">Company</th>
            <th class="py-1">Sector</th>
            <th class="py-1">Source</th>
            <th class="py-1">Added By</th>
            <th class="py-1">When</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in sampleAdditions" :key="row.id" class="border-b last:border-0">
            <td class="py-1">{{ row.company }}</td>
            <td class="py-1">{{ row.sector }}</td>
            <td class="py-1">{{ row.source }}</td>
            <td class="py-1">{{ row.addedBy }}</td>
            <td class="py-1">{{ row.when }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </DashboardDetailLayout>
</template>

<script setup>
import DashboardDetailLayout from '../DashboardDetailLayout.vue'
import MetricCard from '../MetricCard.vue'
import ChartPlaceholder from '../ChartPlaceholder.vue'
import SampleBadge from '../SampleBadge.vue'

const sampleAdditions = [
  { id: 1, company: 'Northstar Avionics',    sector: 'Avionics',         source: 'Import CSV',   addedBy: 'nchui',    when: '8 min ago' },
  { id: 2, company: 'Kestrel Fabrication',   sector: 'Machining',        source: 'Manual',       addedBy: 'jdoe',     when: '22 min ago' },
  { id: 3, company: 'Orbit Polymers',        sector: 'Composites',       source: 'De-dupe split',addedBy: 'system',   when: '1 hr ago' },
  { id: 4, company: 'Apex Propulsion Labs',  sector: 'Propulsion',       source: 'ZoomInfo enrich', addedBy: 'system', when: '2 hr ago' },
  { id: 5, company: 'Halcyon Sensors',       sector: 'Electronics',      source: 'Import CSV',   addedBy: 'nchui',    when: '3 hr ago' },
]
</script>